import { useParams } from "react-router";
import { ErrValidationFailedContextProvider } from "@/shared/lib/errors/err-validation-failed-context";
import { useRelationshipsRelationshipShowQuery } from "@/services/backend/relationships/api/service";
import { CommitmentCard } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/_components/commitment-card";

export function DataRoute() {
  const { relationshipId, commitmentId } = useParams();
  const { data: relationship } = useRelationshipsRelationshipShowQuery({
    id: relationshipId!,
  });

  const commitment = relationship?.commitments.find(
    (c) => c.id === commitmentId,
  );

  if (!commitment) return null;

  return (
    <div className="grid gap-2">
      {/* The commitment is not the work order edited on the other tabs. */}
      <ErrValidationFailedContextProvider>
        <CommitmentCard commitment={commitment} />
      </ErrValidationFailedContextProvider>
    </div>
  );
}
